import React from 'react'

export default function Section2() {
    return (
        <div className='section2-bg relative'>
            <div className='min-h-screen text-white py-10 grid content-center relative' style={{ zIndex: 1 }}>
                <h1 className='custom-font text-center'>About CRYPWALLET</h1>
                <p className='font-poppins font-normal text-center w-[90%] lg:w-[50%] mx-auto'>CrypWallet is a next-gen, non-custodial crypto wallet designed for seamless digital asset management. With multi-chain support, built-in trading, staking rewards, and top-tier security, CrypWallet ensures you have full control over your crypto journey.</p>
                <img src='/assets/img/qr.svg' className='backdrop-blur-sm w-[80%] md:w-[50%] lg:w-[20%] mx-auto'></img>
                <h1 className='custom-font scan-size text-center mt-2' style={{ textShadow: " 2px 2px 5px #00000080" }}>
                    Scan<br /> OR <br /> Click link to get app</h1>
                <a className='flex justify-center text-white mt-3 truncate' href='https://new.express.adobe.com/id/urn:aaid:sc:AP:805607f8-c73f-4b4e-b7c6-ae1cd0711c4c?category=search' target='_blank'>
                    <p className='px-3 md:px-5 py-3 bg-white/20 rounded-full w-[90%] lg:w-auto truncate'> https://new.express.adobe.com/id/urn:aaid:sc:AP:805607f8-c73f-4b4e-b7c6-ae1cd0711c4c?category=search</p>
                </a>
            </div>
            <img src='/assets/img/globe.svg' className='absolute z-0 bottom-0'></img>
        </div>
    )
}
